import React, { useState, Component } from 'react';
import {
  BrowserRouter as Router,
  useLocation
} from 'react-router-dom';
import Routes from "../Routes/Routes";

export default function Content({ isOpen, toggle, imagetoggle, setToggleFalse }) {
  const location = useLocation();

  // Routes that should not use the main wrapper styling
  const standaloneRoutes = ['/terms-viewer'];
  const isStandalonePage = standaloneRoutes.some(route =>
    location.pathname.includes(route)
  );

  return (
    <div
      className={isStandalonePage ? '' : (isOpen ? 'main is-open' : 'main')}
      onClick={isStandalonePage ? undefined : setToggleFalse}
    >
      {/* <Route exact path="/" component={Dashboard} />
        <Route path="/about" component={About} /> */}
      <Routes imagetoggle={imagetoggle}> </Routes>
    </div>
  );
}
